import React, { useState } from "react";
import PlacesInput from "../../UI/GooglePlacesAutocomplete/PlacesInput";
import {
  ModalField,
  ModalFields,
  ModalForm,
  ModalInput,
} from "../../../design-system/patterns/modal-form";

/**
 * Store collection address edit. One of the nine modal forms.
 *
 * The payload is the same five keys it always was, and the Google Places
 * fill-down still writes city, province and postal code from the chosen place.
 */

const EditDeliveryForm = ({ open = true, initial, onSubmit, onCancel, submitting }) => {
  const [formState, setFormState] = useState({
    address_line1: initial?.address_line1 || "",
    address_line2: initial?.address_line2 || "",
    city: initial?.city || "",
    province: initial?.province || "",
    postal_code: initial?.postal_code || "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormState((s) => ({ ...s, [name]: value }));
  };

  const fillFromPlace = (placeDetails) => {
    if (!placeDetails || !placeDetails.address) return;

    handleChange({ target: { name: "address_line1", value: placeDetails.address } });

    if (placeDetails.addressComponents && placeDetails.addressComponents.length > 0) {
      placeDetails.addressComponents.forEach((component) => {
        if (component.types.includes("postal_code")) {
          handleChange({ target: { name: "postal_code", value: component.long_name } });
        }
        if (
          component.types.includes("locality") ||
          component.types.includes("sublocality")
        ) {
          handleChange({ target: { name: "city", value: component.long_name } });
        }
        if (component.types.includes("administrative_area_level_1")) {
          handleChange({ target: { name: "province", value: component.long_name } });
        }
      });
    }
  };

  return (
    <ModalForm
      open={open}
      title="Edit store collection address"
      onClose={onCancel}
      onSubmit={() => onSubmit?.(formState)}
      submitting={submitting}
      submitLabel="Save address"
      submittingLabel="Saving"
    >
      <ModalFields cols={2}>
        <ModalField label="Address line 1" full>
          <PlacesInput
            name="address_line1"
            value={formState.address_line1}
            onChange={handleChange}
            onPlaceSelect={fillFromPlace}
            placeholder="Start typing your address"
          />
        </ModalField>

        <ModalField label="Address line 2" optional full>
          <PlacesInput
            name="address_line2"
            value={formState.address_line2}
            onChange={handleChange}
            placeholder="Apartment, suite, unit"
          />
        </ModalField>

        <ModalField label="City">
          <ModalInput
            name="city"
            value={formState.city}
            onChange={handleChange}
            disabled={submitting}
          />
        </ModalField>

        <ModalField label="Province">
          <ModalInput
            name="province"
            value={formState.province}
            onChange={handleChange}
            disabled={submitting}
          />
        </ModalField>

        <ModalField label="Postal code">
          <ModalInput
            name="postal_code"
            value={formState.postal_code}
            onChange={handleChange}
            inputMode="numeric"
            disabled={submitting}
          />
        </ModalField>
      </ModalFields>
    </ModalForm>
  );
};

export default EditDeliveryForm;
